<!-- src/components/Orders/OrdersList/OrderItemMenu.vue -->
<template>
    <actions-menu
    v-model:dialogConsult="dialogConsult"
    :ShowDialogConsult="true"
    :dialogEdit="false"
    :ShowDialogEdit="false"
    :ShowDialogDelete="false"
    :ShowDialogEnforcePO="DestroyTimer"
      v-model:dialogEnforcePO="dialogEnforcePO"
      :Id="Id"
    />
    <dialogDelete :title="itemTitle" :width="'460px'" :yes="forceOrder" v-model="dialogEnforcePO" :DialogType="'EnforcePO'" :loader="loader"/>
  </template>
  
  <script>
  import actionsMenu from "@/genericComponent/actionsMenu.vue";
  import dialogDelete from "@/genericComponent/dialogDelete.vue";
  import { EnforcePO } from '@/api/index';
  export default {
    name: "OrderItemMenu",
    components: { actionsMenu, dialogDelete },
    props: {
      masterOrderId: {
        type: String,
        required: true,
      },
      itemTitle: {
        type: String,
        required: true,
      },
      getMasterOrdersAfterDeleted: Function,
      Id: [String, Number],
      dialogEdit: {
        type: String,
        default: "OrderDetails",
      },
      DestroyTimer: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialogEnforcePO: false,
        dialogConsult: false,
        loader: false,
      };
    },
    methods: {
      forceOrder() {
        this.loader = true;
        
        EnforcePO(this.masterOrderId)
          .then(() => {
            this.getMasterOrdersAfterDeleted();
            this.ActiveSavedSnackBar();
          })
          .catch(() => {
            this.activeWarningSnackBar();
          }).finally(() => {
            this.loader = false;
            this.dialogEnforcePO = false;
          });
      },
     
      ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
      getParent(name) {
        let p = this.$parent;
        while (p) {
          if (p.$options.name === name) {
            return p;
          } else {
            p = p.$parent;
          }
        }
        return null;
      },
    },
    
    watch: {
      dialogConsult(newValue) {
        if (newValue) {
         this.$router.push({ name: 'MasterOrderDetails', params: { id: this.masterOrderId } });
        }
      },
    },
  };
  </script>
  